import React from 'react';
import { Link } from 'react-router-dom';

export interface InsuranceStep {
  title: string;
}

interface InsuranceStepIndicatorProps {
  currentStep: number;
  steps: InsuranceStep[];
  links: string[];
}

const InsuranceStepIndicator: React.FC<InsuranceStepIndicatorProps> = ({
  currentStep,
  steps,
  links,
}) => {
  return (
    <div className="d-flex flex-column h-100 pt-2">
      {steps.map((step, index) => (
        <div key={step.title} className="d-flex flex-column flex-grow-1">
          {index < currentStep ? (
            <div className="d-flex flex-row">
              <span className="material-icons text-success">check</span>
              <div className="d-flex flex-column">
                <p className="mb-0 text-secondary">{step.title}</p>
                <Link to={links[index]} className="mb-0 text-primary">
                  Editar etapa
                </Link>
              </div>
            </div>
          ) : (
            <p
              className={`mb-0 ${
                index === currentStep ? 'font-weight-bold text-success' : 'text-secondary'
              }`}
            >
              {index + 1}. {step.title}
            </p>
          )}

          {index < steps.length - 1 && <div className="border-left my-2 ml-1 flex-grow-1" />}
        </div>
      ))}
    </div>
  );
};

export default InsuranceStepIndicator;
